"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeValueHandlerAdapter_1 = require("./NodeValueHandlerAdapter");
/**
 * Converts GraphQL strings to RDF string terms, which can have a custom language or datatype.
 */


var NodeValueHandlerString =
/*#__PURE__*/
function (_NodeValueHandlerAdap) {
  _inherits(NodeValueHandlerString, _NodeValueHandlerAdap);

  function NodeValueHandlerString(util, settings) {
    _classCallCheck(this, NodeValueHandlerString);

    return _possibleConstructorReturn(this, _getPrototypeOf(NodeValueHandlerString).call(this, 'StringValue', util, settings));
  }

  _createClass(NodeValueHandlerString, [{
    key: "handle",
    value: function handle(valueNode, fieldName, convertContext) {
      var contextEntry = convertContext.context[fieldName];
      var language = null;
      var datatype = null;

      if (contextEntry && typeof contextEntry !== 'string') {
        if (contextEntry['@language']) {
          language = contextEntry['@language'];
        } else if (contextEntry['@type']) {
          datatype = this.util.dataFactory.namedNode(contextEntry['@type']);
        }
      }

      return {
        terms: [this.util.dataFactory.literal(valueNode.value, language || datatype)]
      };
    }
  }]);

  return NodeValueHandlerString;
}(NodeValueHandlerAdapter_1.NodeValueHandlerAdapter);

exports.NodeValueHandlerString = NodeValueHandlerString;